<!-- Template for the action button that parent component can render -->
<ng-template #actionButton>
  <iris-button 
    id="pendo-insurance-needs-review"
    data-test="insurance-review-exit-button"
    [type]="IrisButtonTypes.PRIMARY"
    (click)="confirm()"
  >
    Next
  </iris-button>
</ng-template>

<div class="insurance-review-wrapper">
  <img alt="Insurance Needs Review" src="/assets/setup/insurance.svg">
  <h4 class="insurance-review-header" data-test="header-insurance-review">
    Your {{isEAP ? 'EAP' : 'insurance'}} needs review
  </h4>
  <p data-test="insurance-review-paragraph-text">{{ reviewParagraphText }}</p>

  @if (!fromDirectBooking) {
    <iris-button-container>
      <ng-container *ngTemplateOutlet="actionButton"></ng-container>
    </iris-button-container>
  }
</div>
